import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineLabDetailSchema: CollectionCreateSchema = {
  name: CollectionName.WineLabDetail,
  fields: [
    {
      name: "search_id",
      type: "string",
      infix: true,
    },
    {
      name: "name",
      type: "string",
      infix: true,
    },
    {
      name: "street",
      type: "string",
      infix: true,
    },
    {
      name: "city",
      type: "string",
      infix: true,
    },
    {
      name: "postcode",
      type: "string",
      infix: true,
    },
    {
      name: "contact_name",
      type: "string",
      infix: true,
    },
    {
      name: "contact_title",
      type: "string",
      infix: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
